import Common from "../../Common";
import Template from "./permission/Template";

interface Body {
	permission: number
}

const Permission = class extends Common {
	template: InstanceType<typeof Template>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.template = new Template(headers)
	}

	update = (permissionId: id, body: Body) =>
		this.patch(`/acl/permission/${permissionId}`, body)

	delete = (permissionId: id) =>
		this.doDelete(`/acl/permission/${permissionId}`)
}

export default Permission
